import styled from 'styled-components';

import { isFocused } from '@belong/themes';

export const ChatTranscriptWrapper = styled.div`
  padding: 16px;
`;

export const ScrollBox = styled.div`
  // To stick scroll to bottom:
  display: flex;
  flex-direction: column-reverse;

  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  overscroll-behavior: contain;

  &:focus {
    ${isFocused()};
    outline-offset: -2px;
  }
`;

export const FadeIn = styled.div`
  // Safari seems to want to flash the 100% keyframe at the start of the animation.
  // This 0% no opacity keyframe is to fix that.
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    1% {
      opacity: 0.5;
      transform: translateY(10px);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
  animation: fadeIn 200ms ease-out;

  @media (prefers-reduced-motion) {
    animation-duration: 0s;
  }
`;
